// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__37WaI","loaderOuter":"PageOverlayLoader_loaderOuter__tZETN"};